

































































import Vue from "vue";
import { ref } from "@vue/composition-api";

const validateStrength = function(message, type, discount, valid) {
  if (!type) {
    return "";
  }

  const template = message;
  // @ts-ignore
  const r = template.match(/\{[\w]+\}/g);

  // @ts-ignore
  const _urlRegex = template.match(
    /* eslint-disable */
    /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi
  );

  const strengthRating = [];
  const strengthLabel = [];
  const usedTags = [];

  const tags = ["ShopName", "FirstName", "DiscountCode"];

  r &&
    r.forEach(state => {
      const stateItem = state.split(/{|}/g)[1];
      usedTags.push(stateItem);
    });

  // If the message length is less than or equal to 50 lower the strength and add the validation label
  if (message.length <= 50) {
    strengthRating.push(0);
    strengthLabel.push({
      label: "Your message length is quite low",
      tag: null
    });
  } else {
    // Message length checked passed so +1 to strength rating
    strengthRating.push(1);
  }

  // No tags have been found so set strength to low and add the validation labels
  if (usedTags.length === 0) {
    strengthRating.push(0);
    strengthRating.push(0);
    strengthLabel.push(
      { label: "Add your Shop Name", tag: "{ShopName}" },
      {
        label: "Personalize the message with the customers name",
        tag: "{FirstName}"
      }
    );
  } else {
    // There have been some tags found so set strength based on if the tags are the same as the recommended above
    // If the found tags are not in the recommended list add the validation labels
    const usedTagsStrength = [];
    tags.every(value => usedTagsStrength.push(usedTags.includes(value)));
    if (!usedTagsStrength[0]) {
      // ShopName hasn't been used
      strengthRating.push(0);
      strengthLabel.push({ label: "Add your Shop Name", tag: "{ShopName}" });
    } else {
      strengthRating.push(1);
    }
    if (!usedTagsStrength[1]) {
      // FirstName hasn't been used
      strengthRating.push(0);
      strengthLabel.push({
        label: "Personalize the message with the customers name",
        tag: "{FirstName}"
      });
    } else {
      strengthRating.push(1);
    }
  }

  if (type === "CAMPAIGN") {
    const usedTagsStrength = [];
    tags.every(value => usedTagsStrength.push(usedTags.includes(value)));
    if (usedTagsStrength[2] && discount && !valid) {
      // FirstName hasn't been used
      strengthRating.push(0);
      strengthLabel.push({
        label:
          "No discount has been configured but the tag {DiscountCode} was used"
      });
    } else if (usedTagsStrength[2] && !discount) {
      strengthRating.push(0);
      strengthLabel.push({
        label: "The tag {DiscountCode} was used but no discount is configured"
      });
    } else {
      strengthRating.push(1);
    }
    if (usedTags.includes("ShopUrl") || _urlRegex) {
      strengthRating.push(2);
    } else {
      strengthLabel.push({
        label: "You should include a link to your Shop in your message",
        tag: "{ShopUrl}"
      });
    }
  }

  if (type === "CUSTOMER_REACTIVATION") {
    if (usedTags.includes("ShopUrl") || _urlRegex) {
      strengthRating.push(2);
    } else {
      strengthLabel.push({
        label: "You should include a link to your Shop in your message",
        tag: "{ShopUrl}"
      });
    }
  }

  if (type === "ABANDONED_CHECKOUT") {
    if (usedTags.includes("CheckoutUrl")) {
      strengthRating.push(2);
    } else {
      strengthLabel.push({
        label: "You should include the Checkout Url in your message",
        tag: "{CheckoutUrl}"
      });
    }
  }
  let strengthRatingColor = "succes";
  let strengthRatingLabel = "";
  let strengthRatingPercentage =
    (strengthRating.reduce((a, b) => a + b) / 4) * 100;
  if (type === "ABANDONED_CHECKOUT" || type === "CUSTOMER_REACTIVATION") {
    strengthRatingPercentage =
      (strengthRating.reduce((a, b) => a + b) / 5) * 100;
  }

  if (type === "CAMPAIGN") {
    strengthRatingPercentage = Math.round(
      (strengthRating.reduce((a, b) => a + b) / 6) * 100
    );
  }

  if (type === "SHIPPING_CONFIRMATION") {
    strengthRatingPercentage = Math.round(
      (strengthRating.reduce((a, b) => a + b) / 3) * 100
    );
  }
  switch (strengthRatingPercentage) {
    case 100:
      strengthRatingLabel = "Strong";
      strengthRatingColor = "success";
      break;
    case 83:
      strengthRatingLabel = "High";
      strengthRatingColor = "info";
      break;
    case 75:
      strengthRatingLabel = "High";
      strengthRatingColor = "info";
      break;
    case 67:
      strengthRatingLabel = "High";
      strengthRatingColor = "info";
      break;
    case 60:
      strengthRatingLabel = "Medium";
      strengthRatingColor = "warning";
      break;
    case 50:
      strengthRatingLabel = "Medium";
      strengthRatingColor = "warning";
      break;
    case 40 || 33:
      strengthRatingLabel = "Low";
      strengthRatingColor = "error";
      break;
    case 25:
      strengthRatingLabel = "Low";
      strengthRatingColor = "error";
      break;
    default:
      strengthRatingLabel = "Low";
      strengthRatingColor = "error";
      break;
  }

  return {
    strengthRatingColor,
    strengthRatingLabel,
    strengthRating: strengthRatingPercentage,
    strengthLabel
  };
};

export default Vue.extend({
  props: ["message", "func", "type", "discount", "valid"],
  setup(props, context) {
    const strengthLabelsActive = ref(false);

    function addTag(tag) {
      // @ts-ignore
      props.func(tag);
    }

    return {
      addTag,
      validateStrength,
      strengthLabelsActive
    };
  }
});
